var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { claimSystemParameterName, loadConfigurationParameterName, } from "utility/constants";
var linkBase = function () {
    var _a = __read(window.location.hash.split("?"), 2), path = _a[0], search = _a[1];
    var pathName = window.location.pathname;
    var params = new URLSearchParams(search);
    var hasParams = params.toString().length > 0;
    return (window.location.origin +
        pathName +
        path +
        (hasParams ? "?".concat(params.toString(), "&") : "?"));
};
export var getSharableLink = function (configurationId) {
    var linkParam = "".concat(loadConfigurationParameterName, "=").concat(configurationId);
    return linkBase() + linkParam;
};
export var getClaimSystemLink = function (claimId) {
    var claimParam = "".concat(claimSystemParameterName, "=").concat(claimId);
    return linkBase() + claimParam;
};
